import { makeStyles } from '@material-ui/styles';
import { Chip } from '@progress/kendo-react-buttons';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import {
  GridCellProps,
  GridCustomFilterCellProps,
} from '@progress/kendo-react-grid';
import {
  getIncidentStatusOptions,
  incidentStatusTextMap,
  incidentStatusToTypeMap,
} from '../../utils/textMappings';
import {
  useChipStylesBlue,
  useChipStylesGreen,
  useChipStylesGrey,
  useChipStylesOrange,
} from '../ChipStyles';
import { IncidentStatusDropDownFilterCell } from './IncidentStatusDropDownFilterCell';
import { GetString } from '../StringResourceManager';
import {
  arrowRotateCcwIcon,
  checkCircleIcon,
  plusCircleIcon,
  questionCircleIcon,
} from '@progress/kendo-svg-icons';
export const useStyles = makeStyles({
  root: {
    '& .theme-grid--header': {
      fontSize: '1rem',
      color: '#23496B',
    },
  },
});

const useChipStyle = (status: ApiEnums.IncidentStatus) => {
  switch (status) {
    case ApiEnums.IncidentStatus.Open:
      return useChipStylesBlue;
    case ApiEnums.IncidentStatus.InProgress:
      return useChipStylesOrange;
    case ApiEnums.IncidentStatus.Resolved:
    case ApiEnums.IncidentStatus.Closed:
      return useChipStylesGreen;
    case ApiEnums.IncidentStatus.Unknown:
      return useChipStylesGrey;
    default:
      return useChipStylesGrey;
  }
};

const incidentStatusIconMap = (status: ApiEnums.IncidentStatus) => {
  switch (status) {
    case ApiEnums.IncidentStatus.Open:
      return plusCircleIcon;
    case ApiEnums.IncidentStatus.InProgress:
      return arrowRotateCcwIcon;
    case ApiEnums.IncidentStatus.Resolved:
    case ApiEnums.IncidentStatus.Closed:
      return checkCircleIcon;
    default:
      return questionCircleIcon;
  }
};

export const IncidentStatusCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;

  let status: string = incidentStatusTextMap(dataItem.Status);
  let chipStyle: any = useChipStyle(dataItem.Status);
  if (status) {
    return (
      <td>
        <Chip
          className={chipStyle().root}
          text={GetString(status)}
          svgIcon={incidentStatusIconMap(dataItem.Status)}
        />
      </td>
    );
  }
  return <td></td>;
};

export const IncidentStatusFilterCell: any = (
  props: GridCustomFilterCellProps
) => (
  <IncidentStatusDropDownFilterCell
    {...props}
    data={getIncidentStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={incidentStatusToTypeMap}
  />
);
